import React from "react";
import moment from "moment";
import {useEventContext} from "context";

const EventInfo = () => {
    const {event} = useEventContext();
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';

    return (
        <section>
            <h4>{event.name_ru}</h4>
            <p>{moment.unix(event.timeStart).format(dateFormat)} - {moment.unix(event.timeStop).format(dateFormat)}</p>
        </section>
    );
};

export default EventInfo;

